<template>
    <BaseDialog
        :showDialog="showDialog"
        :close="closeDialog"
        headline="lang_PUBLISHING_STATEMENTS_CAPTION_JOURNAL"
        :alvqa="alvqa"
        maxCardHeight="400"
    >
        <template v-slot:dialogText>
            <v-checkbox
                v-model="onlyArchived"
                :disabled="inProcess"
                color="generalCheckbox"
                class="my-3"
                :alvqa="alvqa + '-only-archived'"
                hide-details
            >
                <template v-slot:label>
                    <span
                        class="black--text pt-1"
                        :alvqa="alvqa + '-only-archived-text'"
                    >{{ $t('lang_PUBLISHING_STATEMENTS_CAPTION_JOURNAL_ONLY_ARCHIVED') }}</span>
                </template>
            </v-checkbox>
        </template>
        <template v-slot:dialogActions>
            <v-spacer />
            <BaseButton
                label="lang_GENERAL_BUTTON_CANCEL"
                :disabled="inProcess"
                :alvqa="alvqa + '-cancel'"
                @click="closeDialog"
            />
            <BaseButton
                label="lang_GENERIC_CAPTION_EXPORT"
                :loading="inProcess"
                :disabled="inProcess"
                :alvqa="alvqa + '-export'"
                @click="exportJournal"
            />
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: 'PublishingStatementsJournalDialog',
    components: { BaseDialog, BaseButton },
    data() {
        return {
            alvqa: 'publishing-statements-journal-dialog',
            onlyArchived: true,
        }
    },
    computed: {
        showDialog() { return this.$store.getters.getShowPublishingStatementsJournalDialog },
        inProcess() { return this.$store.getters.getPublishingStatementsJournalInProcess },
    },
    watch: {
        showDialog(show) {
            if (show) this.onlyArchived = true
        },
    },
    methods: {
        closeDialog() {
            if (!this.inProcess) this.$store.commit('setShowPublishingStatementsJournalDialog', false)
        },
        async exportJournal() {
            const success = await this.$store.dispatch('downloadPublishingStatementsJournal', { onlyArchived: this.onlyArchived })
            if (success) this.closeDialog()
        },
    },
}
</script>
